<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
        <div class="mt-6 flex items-center justify-between px-6">
            <h4>{{ Object.entries(this.data).length === 0 ? "ADICIONAR" : "ATUALIZAR" }} CUPOM</h4>
            <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer" style="position: relative; top: -5px"></feather-icon>
        </div>

        <vs-divider class="mb-0"></vs-divider>
        
        <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
            <div class="p-6">

                <div class="w-full">
                    <span> Cupom </span>
                    <vs-input v-model="cupomId" class="w-full" name="coupon-id" v-validate="'required'" data-vv-as="coupon" />
                    <span class="text-danger text-sm" v-show="errors.has('coupon-id')">{{ errors.first('coupon-id') }}</span>
                </div>

                <div class="w-full mt-6">
                    <span> Descrição </span>
                    <vs-input  v-model="coupon.description" class="w-full" name="coupon-description" v-validate="'required'" data-vv-as="DESCRIÇÃO" />
                    <span class="text-danger text-sm" v-show="errors.has('coupon-description')">{{ errors.first('coupon-description') }}</span>
                </div>

                <div class="w-full mt-6">
                    <span class="vx-col"> Expiração </span>
                    <datepicker :highlighted="highlightedFn" format="d de MMMM de yyyy" :language="languages['ptBR']" v-model="expires"></datepicker>
                </div>

                <div class="w-full mt-6">
                    <span class="vx-col"> Valor Mínimo </span>
                    <currency-input
                        :distraction-free="{ hideCurrencySymbol : false }"
                        :auto-decimal-mode="true"
                        :currency="{prefix: 'R$ '}"
                        :allow-negative="false"
                        class="vs-inputx vs-input--input normal hasValue danger"
                        v-model="coupon.minValue"/> 
                    <span class="text-sm w-full text-grey" style="position: relative; top: 0px"> Valor mínimo da conta </span>
                </div>

                <div class="w-full mt-6">
                    <span class="vx-col"> Limite de Utilização </span>
                    <a-input-number size="large" class="w-full" name="coupon-max-utilizations" v-model="coupon.maxUtilizations" :min="0" data-vv-as="LIMITE" />
                    <span class="text-sm w-full text-grey" style="position: relative; top: 0px"> Se for zero, então será ilimitado </span>
                    <!-- <span class="text-danger text-sm" v-show="errors.has('coupon-max-utilizations')">{{ errors.first('coupon-max-utilizations') }}</span> -->
                </div>

                <div class="w-full mt-6">
                    <span class="vx-col"> Tipo </span>
                    <v-select disable-lookup v-model="type" :options="discountTypes" :clearable="false" data-vv-as="TIPO" name="coupon-type" />
                    <span class="text-danger text-sm" v-show="errors.has('coupon-type')">{{ errors.first('coupon-type') }}</span>
                </div>

                <div class="w-full mt-6">
                    <span class="vx-col"> Valor do Cupom </span>
                     <currency-input
                        data-vv-as="VALOR DO CUPOM"
                        v-validate="'required'"
                        name="coupon-value"
                        :distraction-free="{ hideCurrencySymbol : false }"
                        :auto-decimal-mode="true"
                        :currency="{prefix: 'R$ '}"
                        :allow-negative="false"
                        class="vs-inputx vs-input--input normal hasValue danger"
                        v-model="coupon.value"/> 
                    <span class="text-danger text-sm" v-show="errors.has('coupon-value')">{{ errors.first('coupon-value') }}</span>
                </div>
                
                <div class="w-full mt-12" v-show="Object.keys(data).length">
                    <p class="text-grey -mb-1"> UTILIZAÇÕES: {{ coupon.utilizations || 0 }} / {{ coupon.maxUtilizations }} </p>
                    <vs-progress 
                        :percent="(coupon.utilizations * 100) / coupon.maxUtilizations" 
                        :color="((coupon.utilizations * 100) / coupon.maxUtilizations) > 99 ? 'danger' : 'success'" 
                        class="shadow-md" />
                </div>
            </div>
        </VuePerfectScrollbar>

        <div class="flex flex-wrap items-center p-6" slot="footer">
            <vs-button id="save" class="mr-6 vs-con-loading__container" :disabled="!isFormValid" @click="saveCoupon">Salvar</vs-button>
            <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancelar</vs-button>
        </div>

    </vs-sidebar>
</template>

<script>
    import firebase from '@/firebase/firebase'
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    import Datepicker from 'vuejs-datepicker'
    import * as lang from 'vuejs-datepicker/src/locale'
    import vSelect from 'vue-select'
    import { mapActions } from 'vuex'
    import moment from 'moment'

    const defaultcoupon = {
        enabled : true,
        expires : '',
        utilizations : 0,
        maxUtilizations : 0,
        type : 'absolute',
        value : 0,
        minValue : 0,
    }

    const discountTypes = [
        { label : 'Absoluto', value : 'absolute' }
    ]

    const db = firebase.firestore()

    export default {
        components : {
            vSelect,
            Datepicker,
            VuePerfectScrollbar
        },

        props : {
            isSidebarActive : {
                type : Boolean,
                required : true
            },
            data : {
                type : Object,
                required : false
            }
        },

        data () {
            return {
                discountTypes : [{ label : 'Absoluto', value : 'absolute' }],
                languages: lang,
                coupon : defaultcoupon,
                settings: { // perfectscrollbar settings
                    maxScrollbarLength: 60,
                    wheelSpeed: .60,
                },
                highlightedFn : { // date
                    customPredictor(date) {
                        let today = new Date()
                        if (date.getDate() == today.getDate() && date.getMonth() == today.getMonth()) {
                            return true;
                        }
                    }
                },
            }
        },

        watch : {
            data : {
                handler(val) {
                    if(Object.entries(val).length)
                        this.coupon = val
                    else
                        this.coupon = {...defaultcoupon}
                },
                deep : true
            }
        },

        computed : {
            cupomId : {
                get () {
                    return this.coupon.id
                },
                set (val) {
                    this.$set(this.coupon, 'id', val.toUpperCase())
                }
            }, 

            expires : {
                get () {
                    return this.coupon.expires
                },  
                set (val) {
                    if(val)
                        this.$set(this.coupon, 'expires', val)
                    else
                        this.$set(this.coupon, 'expires', '')
                }
            },

            type : {
                get () {
                    const selected = this.discountTypes.find(a => a.value == this.coupon.type)
                    return selected || ''
                },
                set (val) {
                    this.coupon.type = val.value
                }
            },

            isFormValid() {
                return !this.errors.any()
            },

            isSidebarActiveLocal : {
                get () {
                    return this.isSidebarActive
                },
                set (val) {
                    this.$emit('closeSidebar')
                }
            }
        },

        methods : {
            async saveCoupon () {
                if(!await this.$validator.validateAll()) return
                const companyId = this.$store.getters.getCompanyID

                try {
                    this.$vs.loading({container: '#save', scale: .5})
                    await this.isValidCoupom()
                    await db.collection(`/company/${companyId}/coupons`).doc(this.coupon.id).set(this.coupon, { merge : true })
                    this.$message.success('Cupom salvo com sucesso!')
                    this.$emit('closeSidebar')
                    this.addCoupon(this.coupon)
                } catch (err) {
                    this.$error({
                        title : 'Erro!',
                        content: (err.message || err),
                        zIndex: 9999999
                    })
                } finally {
                    this.$vs.loading.close('#save > .con-vs-loading')
                }
            },

            isValidCoupom () {
                return new Promise(async (resolve, reject) => {
                    const prohibitedChar = ['/', ' ', '@', '#', "'", '´', '`', '~', ']', '[', '=', '-', '+', '^', '\\', '?', '!', '|', '$', '%', '¨', '*', '(', ')', '.']
                    const foundChar = prohibitedChar.findIndex(char => this.coupon.id.indexOf(char) >= 0)
                    if(foundChar >= 0)
                        reject('O nome do cupom possui caracteres inválidos.')
                    if(!Object.entries(this.data).length){
                        const couponExists = await this.couponExists(this.coupon.id)
                        if(couponExists)
                            reject(couponExists)
                    if(this.coupon.id.length > 20)
                        reject('O nome do cupom deve ter no máximo 20 caracteres.')
                    }

                    resolve(true)
                })
                
            },

            ...mapActions('coupons', ['addCoupon', 'couponExists'])
        }
    }
</script>

<style  lang="scss" scoped>
    .add-new-data-sidebar {
        ::v-deep .vs-sidebar--background {
            z-index: 52010;
        }

        ::v-deep .vs-sidebar {
            z-index: 52010;
            width: 400px;
            max-width: 90vw;

            .img-upload {
                margin-top: 2rem;

                .con-img-upload {
                    padding: 0;
                }

                .con-input-upload {
                    width: 100%;
                    margin: 0;
                }
            }
        }
    }

    .scroll-area--data-list-add-new {
        // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
        height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
    }
</style>